import { defineComponent as _defineComponent } from 'vue'
import ListItem from './ListItem.vue';

import IListItem from '../interfaces/IListItem';

export default /*#__PURE__*/_defineComponent({
  props: {
  results: {
    type: Object as () => [IListItem],
    required: true,
  },
  highlight: {
    type: Number,
  },
},
  emits: ['deleteItem'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props




const __returned__ = { props, emit, ListItem, IListItem }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})